import { render, staticRenderFns } from "./ProductBubble.vue?vue&type=template&id=681360cc&scoped=true&"
import script from "./ProductBubble.vue?vue&type=script&lang=js&"
export * from "./ProductBubble.vue?vue&type=script&lang=js&"
import style0 from "./ProductBubble.vue?vue&type=style&index=0&id=681360cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681360cc",
  null
  
)

export default component.exports